import Container from './layout-wrapper.vue'

Container.install = Vue => Vue.component(Container.name, Container)

export default Container
